<template>
  <div class="max-w-7xl mx-auto px-6 lg:px-8">
    <PageTitle v-bind:title="title" v-bind:admin="true" />

    <button
      @click.prevent="showAddForm"
      type="button"
      class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 mt-4 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:w-auto sm:text-sm"
    >
      Новая запись
    </button>
    <div
      v-if="showAddModal"
      class="fixed z-10 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <!--
      Background overlay, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
        ></div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >

        <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
        <div
          class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
        >
          <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
            <button
              @click.prevent="cancelAdding"
              type="button"
              class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              <span class="sr-only">Close</span>
              <!-- Heroicon name: outline/x -->
              <svg
                class="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div class="sm:flex sm:items-start">
            <div
              class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10"
            >
              <svg
                class="h-6 w-6 text-green-600"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
              <h3
                class="text-lg leading-6 font-medium text-gray-900"
                id="modal-title"
              >
                Новая запись
              </h3>
              <ErrorMessage
                v-if="errors.add"
                :error="errors.add"
                class="mt-2"
              />
              <div class="mt-2">
                <div>
                  <label
                    for="email"
                    class="block text-sm font-medium text-gray-700"
                    >Наименование</label
                  >
                  <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                      v-model="name"
                      type="text"
                      name="name"
                      id="name"
                      :class="[
                        'block w-full pr-10  focus:outline-none  sm:text-sm rounded-md',
                        errors.validationAdd && errors.validationAdd.name
                          ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                          : '',
                      ]"
                    />
                    <div
                      v-if="errors.validationAdd && errors.validationAdd.name"
                      class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                    >
                      <svg
                        class="h-5 w-5 text-red-500"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                  </div>
                  <p
                    v-if="errors.validationAdd && errors.validationAdd.name"
                    class="mt-2 text-sm text-red-600"
                  >
                    {{ errors.validationAdd.name[0] }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <button
              @click.prevent="addRecord"
              type="button"
              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
            >
              Сохранить
            </button>
            <button
              @click.prevent="cancelAdding"
              type="button"
              class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
            >
              Отмена
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="showEditModal"
      class="fixed z-10 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <!--
      Background overlay, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
        ></div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >

        <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
        <div
          class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
        >
          <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
            <button
              @click.prevent="cancelEditing"
              type="button"
              class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              <span class="sr-only">Close</span>
              <!-- Heroicon name: outline/x -->
              <svg
                class="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div class="sm:flex sm:items-start">
            <div
              class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10"
            >
              <svg
                class="h-6 w-6 text-green-600"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
              <h3
                class="text-lg leading-6 font-medium text-gray-900"
                id="modal-title"
              >
                Редактировать элемент # {{ id }}
              </h3>
              <ErrorMessage
                v-if="errors.edit"
                :error="errors.edit"
                class="mt-2"
              />
              <div class="mt-2">
                <div>
                  <label
                    for="email"
                    class="block text-sm font-medium text-gray-700"
                    >Наименование</label
                  >
                  <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                      v-model="name"
                      type="text"
                      name="name"
                      id="name"
                      :class="[
                        'block w-full pr-10  focus:outline-none  sm:text-sm rounded-md',
                        errors.validationEdit && errors.validationEdit.name
                          ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                          : '',
                      ]"
                    />
                    <div
                      v-if="errors.validationEdit && errors.validationEdit.name"
                      class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                    >
                      <svg
                        class="h-5 w-5 text-red-500"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                  </div>
                  <p
                    v-if="errors.validationEdit && errors.validationEdit.name"
                    class="mt-2 text-sm text-red-600"
                  >
                    {{ errors.validationEdit.name[0] }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <button
              @click.prevent="editRecord(id)"
              type="button"
              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
            >
              Сохранить
            </button>
            <button
              @click.prevent="cancelEditing"
              type="button"
              class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
            >
              Отмена
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="alert alert-danger" v-if="errors.load">
      {{ errors.load }}
    </div>
    <Loader v-if="loading" />
    <div v-else-if="data.length" class="my-8">
      <ErrorMessage v-if="errors.delete" :error="errors.delete" class="mt-2" />

      <div class="flex flex-col">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div
            class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
          >
            <div
              class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
            >
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      ID
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Наименование
                    </th>

                    <th scope="col" class="relative px-6 py-3">
                      <span class="sr-only">Delete</span>
                    </th>
                    <th scope="col" class="relative px-6 py-3">
                      <span class="sr-only">Edit</span>
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr v-for="item in data" :key="item.id">
                    <td
                      class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                    >
                      {{ item.id }}
                    </td>
                    <td
                      class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                    >
                      {{ item.name }}
                    </td>
                    <td
                      class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium"
                    >
                      <form @submit.prevent="deleteRecord(item.id)">
                        <button
                          type="submit"
                          class="text-red-600 hover:text-red-900"
                        >
                          Удалить
                        </button>
                      </form>
                    </td>
                    <td
                      class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium"
                    >
                      <button
                        @click.prevent="showEditForm(item)"
                        type="button"
                        class="text-indigo-600 hover:text-indigo-900"
                      >
                        Редактировать
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <table class="table">
        <thead>
          <tr>
            <th>id</th>
            <th>Наименование</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in data" :key="item.id">
            <td>{{ item.id }}</td>
            <td>{{ item.name }}</td>
            <td>
              <form @submit.prevent="deleteRecord(item.id)">
                <button type="submit" class="btn btn-danger">Удалить</button>
              </form>
            </td>
            <td>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="showEditForm(item)"
              >
                Редактировать
              </button>
            </td>
          </tr>
        </tbody>
      </table> -->

  <!-- Add Item form -->
  <!-- <button type="button" class="btn btn-primary" @click.prevent="showAddForm">
      + Новая запись
    </button>
    <div
      class="modal fade"
      id="addForm"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Новая запись</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="name" class="col-form-label">Наименование:</label>
              <input
                type="text"
                class="form-control"
                id="name"
                name="name"
                v-model="name"
              />
              <div
                class="alert alert-danger"
                v-if="errors.validationAdd && errors.validationAdd.name"
              >
                {{ errors.validationAdd.name[0] }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click.prevent="cancelAdding"
            >
              Отмена
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="addRecord"
            >
              Сохранить
            </button>
          </div>
          <div class="alert alert-danger" v-if="errors.add">
            {{ errors.add }}
          </div>
        </div>
      </div>
    </div> -->
  <!-- END of Add Item form -->

  <!-- Edit Item form -->
  <!-- <div
      class="modal fade"
      id="editForm"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Редактировать элемент # {{ id }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <input type="hidden" name="id" v-model="id" />
            <div class="form-group">
              <label for="name" class="col-form-label">Наименование:</label>
              <input
                type="text"
                class="form-control"
                id="name"
                name="name"
                v-model="name"
              />
              <div
                class="alert alert-danger"
                v-if="errors.validationEdit && errors.validationEdit.name"
              >
                {{ errors.validationEdit.name[0] }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click.prevent="cancelEditing"
            >
              Отмена
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="editRecord(id)"
            >
              Сохранить
            </button>
          </div>
          <div class="alert alert-danger" v-if="errors.edit">
            {{ errors.edit }}
          </div>
        </div>
      </div>
    </div> -->
  <!-- END of Edit Item form -->
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader";
// import jQuery from "jquery";
import PageTitle from "@/components/PageTitle";
import ErrorMessage from "@/components/ErrorMessage";

export default {
  components: {
    Loader,
    PageTitle,
    ErrorMessage,
  },
  data() {
    return {
      loading: true,
      data: [],
      id: 0,
      name: "",
      errors: {
        load: "",
        add: "",
        delete: "",
        edit: "",
        validationAdd: {},
        validationEdit: {},
      },
      title: "Список состояний глав",
      showAddModal: false,
      showEditModal: false,
    };
  },

  async mounted() {
    this.loadRecords();
  },
  methods: {
    clearErrors() {
      this.errors.load = "";
      this.errors.add = "";
      this.errors.delete = "";
      this.errors.edit = "";
    },

    async loadRecords() {
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get("admin/chapterstates");
        this.data = response.data;
        this.loading = false;
      } catch (e) {
        this.errors.load = "Ошибка при загрузке данных";
      }
    },
    showAddForm() {
      this.name = "";
      this.errors.validationAdd = {};
      this.clearErrors();
      //   jQuery("#addForm").modal("show");
      this.showAddModal = true;
    },
    cancelAdding() {
      this.name = "";
      //   jQuery("#addForm").modal("hide");
      this.showAddModal = false;
    },
    //
    // Add new record.
    //
    async addRecord() {
      this.errors.validationAdd = {};
      this.clearErrors();
      try {
        let response = await axios.post("admin/chapterstates", {
          name: this.name,
        });
        if (response.status == 200) {
          this.name = "";
          this.loadRecords();
          //   jQuery("#addForm").modal("hide");
          this.showAddModal = false;
        }
      } catch (e) {
        if (e.response.status == 422) {
          this.errors.validationAdd = e.response.data.errors;
        } else if (e.response.status == 520) {
          this.errors.add = "Ошибка при создании записи.";
        } else {
          this.errors.add = "Неизвестная ошибка при создании записи.";
        }
      }
    },
    //
    // Delete record.
    //
    async deleteRecord(id) {
      this.clearErrors();
      try {
        let response = await axios.delete("admin/chapterstates/" + id);
        if (response.status == 200) {
          // удаление эл-та из списка "на клиенте":
          let index = this.data.findIndex((tmpdata) => tmpdata.id == id);
          this.data.splice(index, 1);
        }
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.delete = e.response.data.error;
        } else {
          this.errors.delete = "Неизвестная ошибка при удалении.";
        }
      }
    },

    showEditForm(item) {
      this.id = item.id;
      this.name = item.name;
      this.errors.validationEdit = {};
      this.clearErrors();
      //   jQuery("#editForm").modal("show");
      this.showEditModal = true;
    },
    cancelEditing() {
      this.name = "";
      //   jQuery("#editForm").modal("hide");
      this.showEditModal = false;
    },
    //
    // Edit record.
    //
    async editRecord(id) {
      this.errors.validationEdit = {};
      this.clearErrors();
      try {
        let response = await axios.post("admin/chapterstates/" + id, {
          id: this.id,
          name: this.name,
          _method: "PUT",
        });
        if (response.status == 200) {
          this.id = 0;
          this.name = "";
          this.loadRecords();
          //   jQuery("#editForm").modal("hide");
          this.showEditModal = false;
        }
      } catch (e) {
        if (e.response.status == 422) {
          this.errors.validationEdit = e.response.data.errors;
        } else if (e.response.status == 520) {
          this.errors.edit = "Ошибка при редактировании записи.";
        } else {
          this.errors.edit = "Неизвестная ошибка при редактировании записи.";
        }
      }
    },
  },
};
</script>